import { Polyline } from 'leaflet';
import { PaintLineString } from '../mapa';
import { LineString, MultiLineString } from 'geojson';
import { Typography } from '@mui/material';

export interface RotaFugaData {
  id: number;
  nome: string;
  idModificou?: string;
  idZas: number;
  obs?: string;
  nivelValidade: number;
  tempoChegada: number;
  tempoSaida?: number;
  comprimento?: number;
  dataCadastro: Date;
  dataModificacao?: Date;
}

export class RotaFuga extends Polyline<LineString | MultiLineString, RotaFugaData> {
  // Propriedades da geometria
  public properties: RotaFugaData;
  public paintOptions: PaintLineString;

  public bbox = this.getBounds();

  // Contrutor da Classe de Área
  constructor(geometry: LineString | MultiLineString, properties: RotaFugaData, paintOptions?: PaintLineString) {
    let latlng: [number, number][] | [number, number][][];

    if (geometry.type === "LineString") {
      latlng = geometry.coordinates.map(coord => [coord[1], coord[0]]);
    } else {
      const a = geometry.coordinates.map(coords => {
        return coords.map((coord) => {
          return [coord[1], coord[0]];
        });
      });
      latlng = a as [number, number][][];
    }

    super(latlng, paintOptions ?? {
      color: "rgba(255, 255, 0, 1)",
      weight: 2,
    });

    this.properties = properties;
    this.paintOptions = paintOptions ?? {};

    this.on({
      mouseover: this.highlightFeature,
      mouseout: this.resetStyle,
      click: this.clickFeature,
    });

    this.bindPopup(this.popUpComponent(), {
      className: "",
      maxWidth: 390,
    });

    this.bindTooltip(this.tooltipComponent(), { direction: "top" });
  }

  private resetStyle = () => this.setStyle(this.paintOptions);
  private highlightFeature = () => (this.paintOptions.paintHovered ? this.setStyle(this.paintOptions.paintHovered) : null);
  private clickFeature = () => (this.paintOptions.paintClick ? this.setStyle(this.paintOptions.paintClick) : null);


  public popUpComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        height: "10em",
        width: "19em",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>{"Rota " + this.properties.nome}</Typography>
        {this.properties.comprimento && <Row title="Comprimento (m)" value={this.properties.comprimento.toSignificantDigits("metros")} />}
        <Row title="Tempo de Chegada (s)" value={this.properties.tempoChegada.toSignificantDigits("segundos")} />
        {this.properties.tempoSaida && <Row title="Tempo de Saída (s)" value={this.properties.tempoSaida.toSignificantDigits("segundos")} />}
      </div>
    );
  }

  public tooltipComponent() {
    return window.JSXToHTML(
      <div style={{
        display: "flex",
        flexDirection: "column",
        justifyItems: "center",
        overflowY: "auto",
      }}>
        <Typography fontSize={"1.2em"} fontWeight={"bold"}>
          {"Rota " + this.properties.nome}
        </Typography>
      </div>
    );
  }
}

interface PropsRow {
  title: string;
  value: string;
}
const Row: React.FC<PropsRow> = (data) => {
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      height: "1.5em",
      padding: "5px",
      borderRadius: "5px",
    }}>
      <Typography fontSize={"1em"} fontWeight={"bold"}>{data.title}</Typography>
      <div style={{ minWidth: "5px", flex: 1 }} />
      <Typography fontSize={"1em"}>{data.value}</Typography>
    </div>
  );
};

